import React from "react";
import call from "./assets/call.svg";
import meetings from "./assets/meeting.svg";
import email from "./assets/email.svg";
import ActivityTask from "./ActivityTask";
import ActivityStatus from "./ActivityStatus";
import ActivityLeadEnquired from "./ActivityLeadEnquired";
import ActivityDemo from "./ActivityDemo";
import demoIcon from "./assets/demo.svg";
import statusChange from "./assets/status-change.svg";
import created from "./assets/lead-created.svg";
import ActivityNote from "./ActivityNote";
import noteIcon from "./assets/note.svg";
import ActivityPayment from "./ActivityPayment";
import payment from "./rupee.svg";
import styles from "./ActivityList.module.css";
import ActivityNegotiation from "./ActivityNegotiation";
import ActivityStage from "./ActivityStage";
import ActivityLead from "./ActivityLead";
import leadEdit from "./assets/edit-activity.svg";
import leadStatus from "./assets/status-activity-change.svg";
import ActivityTaskStatusChange from "./ActivityTaskStatusChange";
import negotiation from "./assets/negotiation.svg";
import ActivityCall from "./ActivityCall";
import activityCall from "./assets/activityCall.svg";
import ActivityComment from "./ActivityComment";
import commentIcon from "./assets/acivityComment.svg";
import AmountEdited from "./EMI/AmountEdited";
import PauseMembership from "./EMI/PauseMembership";
import InstallmentEdited from "./EMI/InstallmentEdited";
import PlanChanged from "./EMI/PlanChanged";
import pauseIcon from "./assets/activityPause.svg";
import ActivitySession from "./ActivitySession";
import ActivityTag from "./ActivityTag";
import ActivityeNACH from "./ActivityeNACH";
import PastPaymentMergeActivity from "./PastPaymentMergeActivity";
import { Box } from "@mui/material";
import ActivityVoxbayCall from "./ActivityVoxbayCall";

function VoxbayIVRList(props: any) {
  const {
    data,
    activeTab,
    listData,
    index,
    employees,
    selectedCurrency,
    selectedLeadData,
  } = props;

  const sideIcon = (type: string) => {
    switch (type) {
      case "CALL":
        return call;

      case "MEETING":
        return meetings;

      case "EMAIL":
        return email;

      case "DEMO":
        return demoIcon;

      default:
        return;
    }
  };

  return (
    <Box sx={{ width: "100%", p: 0, bgcolor: "white" }}>
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Box
          sx={{
            paddingLeft: 2,
          }}
        >
          <Box
            sx={{
              height: "25px",
              width: "25px",
              borderRadius: "50%",
              border: "1px solid #F0F0F0",
              textAlign: "center",
              backgroundColor: "#FFF",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              overflow: "hidden",
            }}
          >
            <div className={styles.activitySideIcon}>
              {<img src={activityCall} alt="activityCall" />}
            </div>
          </Box>
          {activeTab === "activityList" && listData.length - 1 !== index && (
            <Box
              sx={{
                height: "100%",
                width: "1px",
                margin: "0px auto",
                border: "1px solid rgba(102, 112, 133, 0.14)",
              }}
            />
          )}
        </Box>

        {
          <ActivityVoxbayCall
            data={data}
            employees={employees}
            selectedLeadData={selectedLeadData}
          />
        }
      </Box>
    </Box>
  );
}

export default VoxbayIVRList;
